<template>
  <div class="home">
    <div class="home__wrapper screen__home_wrapper">
      <div class="home__content">
        <transition name="fade">
          <div class="home__scroll_to_top" v-if="windowScrollPosition > UserAgent.window.height">
            <div class="home__scroll_to_top_btn" @click="scrollToTop">
              <svg class="home__scroll_to_top_svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><path data-v-14ed5ff6="" d="M367.954,213.588L160.67,5.872c-7.804-7.819-20.467-7.831-28.284-0.029c-7.819,7.802-7.832,20.465-0.03,28.284
          l207.299,207.731c7.798,7.798,7.798,20.486-0.015,28.299L132.356,477.873c-7.802,7.819-7.789,20.482,0.03,28.284
          c3.903,3.896,9.016,5.843,14.127,5.843c5.125,0,10.25-1.958,14.157-5.873l207.269-207.701
          C391.333,275.032,391.333,236.967,367.954,213.588z"></path></svg>
            </div>
          </div>
        </transition>
        <Wrapper />
        <MobilePanel :key="mobilePanelKey" />
        <Intro v-onviewport="DLPSectionView('INTRODUCTION')" class="screen__intro mb--100 mb_mobile--56" />
        <AboutTheExpert v-onviewport="DLPSectionView('ABOUT THE EXPERT')" @read-more-click="mobilePanelKey++; aboutExpertState = true" :expanded="aboutExpertState" :key="(aboutExpertState + UserAgent.window.width + UserAgent.window.height * 1.1)" class="screen__about" :refsState="refsState" />
        <div class="home__flex mb--100 mb_mobile--56 screen__home_flex">
          <div class="home__flex_left">
            <QuestionsMenu />
          </div>
          <div class="home__flex_right">
            <Questions />
          </div>
        </div>
        <References class="screen__refs" :refsState="refsState" />
        <Footer class="screen__footer" />
      </div>
      <div class="home__isi_wrapper">
        <Isi />
      </div>
    </div>
  </div>
</template>

<script>
// components
import Intro from '@/components/Intro/Intro';
import AboutTheExpert from '@/components/AboutTheExpert/AboutTheExpert';
import Questions from '../components/Questions/Questions';
import References from '../components/References/References';
import Footer from '../components/Footer/Footer';
import MobilePanel from '../components/MobilePanel/MobilePanel';
import Wrapper from '../components/Wrapper/Wrapper';
import Isi from '../components/Isi/Isi';
import QuestionsMenu from '../components/QuestionsMenu/QuestionsMenu';

// mixins
import ScrollDepthAnalytics from "@/mixins/ScrollDepthAnalytics";

// vuex
import { mapState } from 'vuex';
import IsOnViewport from '../mixins/IsOnViewport';
import Analytics from '../mixins/Analytics';

export default {
  name: "Home",
  data() {
    return {
      mobilePanelKey: 0,
      aboutExpertState: false,
      refsState: {
        status: false,
      },
    }
  },
  components: {
    Intro,
    AboutTheExpert,
    Questions,
    References,
    Footer,
    MobilePanel,
    Wrapper,
    Isi,
    QuestionsMenu
  },
  mixins: [ScrollDepthAnalytics, IsOnViewport, Analytics],
  computed: {
    ...mapState(['UserAgent', 'windowScrollPosition'])
  },
  methods: {
    scrollPercentageCalculation() {
      const wrapper = document.querySelector('.questions');
      const rect = wrapper.getBoundingClientRect();
      const wrapperHeight = wrapper.scrollHeight;
      const scrolled = window.innerHeight - rect.top;
      let percentage = (scrolled * 100) / wrapperHeight;
      if(percentage > 50) percentage -= 3;
      if(document.querySelector('.ie')) {
        let height = window.innerHeight;
        let limiter = height < 650 ? 1.23 : 2.75;

        if( percentage >= limiter) {
          document.querySelector('.about__main_info').style.opacity = '0'
        } else {
          document.querySelector('.about__main_info').style.opacity = "";
        }
        if(percentage > 98) {
          document.querySelector('.about__expert_photo').setAttribute('style', 'opacity: 0 !important')
        } else {
          document.querySelector('.about__expert_photo').style.opacity = "";
        }
      }
      this.$store.dispatch('SET_SCROLL_PERCENTAGE', percentage);
    },
    scrollToTop() {
      if(this.UserAgent.browser.name === 'safari' && this.UserAgent.browser.os === 'Mac OS') {
        window.scrollTo(0,0)
        setTimeout(() => {
          window.scrollTo(0,0)
        }, 250)
      } else {
        window.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      }
      this.DLPButtonClick('Move to top')
    }
  },
  mounted() {
    document.addEventListener('scroll', this.scrollPercentageCalculation);
  },
  watch: {
    'UserAgent.window.width'() {
      this.mobilePanelKey++;
    },
    'UserAgent.window.height'() {
      this.mobilePanelKey++;
    }
  }
};
</script>

<style scoped lang="scss">
.home {
  &__wrapper {
    width: 100%;
    margin: 0 auto;
    max-width: 1360px;
    display: flex;
    @media (max-width: $tabletMd - 1px) {
      padding-bottom: $isi-height-tablet;
    }
    @media (max-width: $mobile) {
      padding-bottom: $isi-height-mobile;
    }
  }
  &__content {
    width: calc(100% - #{$isi-width});
    padding: 0 24px;
    position: relative;
    @media (max-width: $tabletMd - 1px) {
      width: 100%;
    }
    @media (max-width: $mobile) {
      padding: 0 16px;
    }
  }
  &__scroll_to_top {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  &__scroll_to_top_btn {
    position: fixed;
    bottom: 70px;
    z-index: 50;
    background-color: $primary;
    border: 2px solid $primary;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
    margin-left: -58px;
    -webkit-transition: all .25s ease;
    transition: all .25s ease;
    .screentest & {
      transition: 0s;
    }
    #app.ie & {
      transition: none;
    }

    @media (max-width: $tabletMd - 1px) {
      bottom: calc(#{$isi-height-tablet + $wrapper-size-mobile} + 15px);
    }

    @media (max-width: $mobile) {
      bottom: calc(#{$isi-height-mobile + $wrapper-size-mobile} + 15px);
    }

    &:hover {
      background-color: white;
    }
  }
  &__scroll_to_top_svg {
    transform: rotate(-90deg) translate(50%, -50%);
    width: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    bottom: auto;
    #app.ie & {
      margin-left: 9px;
      margin-top: -8px;
    }
    path {
      fill: white;
      .home__scroll_to_top_btn:hover & {
        fill: $primary;
      }
    }
  }
  &__flex {
    display: flex;

  }
  &__flex_left {
    width: $questions-menu-width;
    min-width: $questions-menu-width;
    @media (max-width: $tabletMd) {
      display: none;
    }
  }
  &__flex_right {
    width: calc(100% - #{$questions-menu-width});
    @media (max-width: $tabletMd) {
      width: 100%;
    }

  }
  &__isi_wrapper {
    width: $isi-width;
    @media (max-width: $tabletMd - 1px) {
      width: 0;
    }
  }
}
</style>
